import React, {createContext, useCallback, useContext, useEffect, useMemo, useState} from 'react'
import {useScript} from "../../Hooks";
import {useSelector} from "react-redux";
import Chatbot from "./index";
import ynToBool from "../../Utils/ynToBool";

const ChatbotContext = createContext({
    isLoaded: false,
});

export const useChatbot = () => useContext(ChatbotContext);

const Script = ({ callbackLoad }) => {
    const [loaded, error] = useScript(
        'https://vertice-ds.s3.us-east-1.amazonaws.com/Assets/scripts/now-requestor-chat-popover-app/now-requestor-chat-popover-app.min.js'
    )
    useEffect(() => {
        if (error) {
            console.error(`Error Chatbot ServiceNow webwidget`)
        } else if (loaded) {
            callbackLoad()
        }
    }, [loaded, error]);
    return <></>
}

const ChatbotProvider = ({ children }) => {
    const [isLoaded, setIsLoaded] = useState(false)
    const [ script, setScript ] = useState(false)
    const User = useSelector(({ oidc: { user } }) => user)
    const handleInit = useCallback(() => {
        if (!isLoaded && script && User && User.access_token) {
            new Chatbot(User.access_token)
            setIsLoaded(true);
        }
    }, [ isLoaded, script, User ])

    const value = useMemo(() => {
        return (
            {
                isLoaded,
                handleInit,
            }
        )
    }, [ isLoaded, handleInit ])

    return (<>
        {(() => {
            if (script || !ynToBool(process.env.REACT_APP_HAS_CHATBOT)) return null;
            return (
                <Script
                    callbackLoad={() => {
                        setScript(true)
                    }}
                />
            )
        })()}
        <ChatbotContext.Provider value={value}>
            { children }
        </ChatbotContext.Provider>
    </>)
}

export default ChatbotProvider;
